import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Element #root nije pronađen.');
}
normalizeDirectRoute();
const root = createRoot(rootElement);
root.render(<LoadingApp data-id="element-175" data-mp="21cadbz1qtvd5" />);
void import('./App').then(({
  App
}) => root.render(<App data-id="element-176" data-mp="26a2ab7h8w7o7" />)).catch((error: unknown) => root.render(<StartupError error={error} data-id="element-177" data-mp="2ab5m9iw69jk5" />));
function LoadingApp() {
  return <main className="flex min-h-screen items-center justify-center bg-background p-6 text-center text-gray-600" data-id="element-178" data-mp="2a8t7tfpmhrbu">
      Učitavamo JumpLand…
    </main>;
}
function StartupError({
  error
}: {
  error: unknown;
}) {
  const message = error instanceof Error ? error.message : 'Nepoznata greška.';
  return <main className="flex min-h-screen items-center justify-center bg-background p-6" data-id="element-179" data-mp="2p1uymoldd4pl">
      <section className="w-full max-w-xl rounded-3xl border border-red-200 bg-white p-8 text-center shadow-sm" data-id="element-180" data-mp="2u0ptiowm2jq2">
        <h1 className="text-2xl font-black text-gray-900" data-id="element-181" data-mp="2xydo1que6ahf">
          Aplikacija se ne može učitati
        </h1>
        <p className="mt-3 text-gray-600" data-id="element-182" data-mp="15n55q5zsmzy1">
          Prikazana je stvarna greška kako preview ne bi ostao prazan.
        </p>
        <pre className="mt-6 overflow-x-auto rounded-2xl bg-red-50 p-4 text-left text-sm text-red-900" data-id="element-183" data-mp="10niv84bcnxsx">
          {message}
        </pre>
      </section>
    </main>;
}
function normalizeDirectRoute() {
  if (window.location.hash || window.location.pathname === '/') return;
  window.history.replaceState(null, '', `/#${window.location.pathname}${window.location.search}`);
}